<template>
  <svg class="icon"
       tabindex="-1"
       focusable="false">
    <use v-bind="{ 'xlink:href': symbolName }"/>
  </svg>
</template>

<script>
  export default {
    name: "AppIcon",
    props: {
      symbol: {
        type: String,
        default: null,
      },
    },
    computed: {
      symbolName() {
        return `#${ this.symbol }`;
      },
    },
  };
</script>
